module.exports = __webpack_public_path__ + "media/search/retail_grayscale-ab3e6e76.png";